<signature-pad
  id="signaturePad"
  #signaturePad
  [options]="signaturePadOptions"
  (drawStart)="drawBegin()"
  (drawEnd)="drawComplete()"
  style="padding-bottom: 6px"
    [ngClass]="{
    'signature-border': templateForPermitForm,
    'signature-border-active': isDrawing && templateForPermitForm
  }"

>
</signature-pad>
